import { getBaseStyles } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOverview/sections/KeyMetricGraphs/KeyMetricGraphs.styles';
import { theme } from 'config';

const styles = getBaseStyles({
  chart: { height: 400 },
  chartContent: {
    padding: '0 2rem 2rem !important',
  },
  headerBlock: {
    background: '#fff !important',
    padding: '0 2rem 1rem !important',
    display: 'flex !important',
    alignItems: 'center !important',
  },
  footer: {
    color: `${theme.darkGray} !important`,
    fontSize: '1rem !important',
    textAlign: 'center',
    width: '100%',
    marginTop: '.75rem',
  },
  footerBlock: {
    background: '#fff !important',
    padding: '1.25rem 2rem 2rem !important',
  },
  formSelect: {
    display: 'flex !important',
    marginLeft: 'auto !important',
    alignItems: 'center !important',
    '& label': {
      marginRight: '.5rem !important',
    },
  },
});

export default styles;
